import { AnyColumn, ItemType } from 'componentregistry';
import { atom, selector } from '@cloudio-saas/statex';
import { getItemProp } from 'platform/GetProp';
import { getChildren } from 'designer/state';
import { itemTypeAtom } from '../../designer/atoms';
import Platform from '../../platform/Platform';
import { ExpressionValue } from '@cloudio-saas/custom-types';

export interface ColumnMenuProps {
  left: number;
  top: number;
  pageId: string;
  appUid: string;
  roleUid: string;
  column: AnyColumn;
  gridItemId: string;
}

export interface RowActionMenuProps {
  left: number;
  top: number;
}

export const rowSelectionMenuOpenAtom = atom<RowActionMenuProps | undefined>({
  path: [
    'ui',
    'grid',
    'rowSelectionMenuOpen',
    ':appUid',
    ':pageId',
    ':itemId',
    ':rowIndex',
  ],
  defaultValue: undefined,
});

export const rowSelectionHeaderMenuOpenAtom = atom<
  RowActionMenuProps | undefined
>({
  path: [
    'ui',
    'grid',
    'rowSelectionHeaderMenuOpen',
    ':appUid',
    ':pageId',
    ':itemId',
  ],
  defaultValue: undefined,
});

export const columnMenuPositionAtom = atom<ColumnMenuProps | undefined>({
  path: [
    'ui',
    'grid',
    'columnMenuPosition',
    ':appUid',
    ':pageId',
    ':gridItemId',
  ],
  defaultValue: undefined,
});

export interface ColumnHideShowProps {
  itemId: string;
  label?: ExpressionValue;
  visible?: boolean;
  type: ItemType;
}

export const columnsHideShowSelector = selector<ColumnHideShowProps[]>({
  path: ['ui', 'grid', 'columnsHideShow', ':appUid', ':pageId', ':gridItemId'],
  get: ({ get, params }) => {
    const { appUid, pageId, gridItemId } = params as unknown as {
      appUid: string;
      pageId: string;
      gridItemId: string;
      platform: Platform;
    };
    const [children] = getChildren(appUid, pageId, gridItemId, get);
    return children.map((itemId) => {
      const label = getItemProp<AnyColumn['props'], 'label'>(
        get,
        appUid,
        pageId,
        itemId,
        'label',
      );
      const visible = getItemProp<AnyColumn['props'], 'visible'>(
        get,
        appUid,
        pageId,
        itemId,
        'visible',
      );
      const type = get(itemTypeAtom, {
        params: { appUid, pageId, itemId },
      });
      return { itemId, label, visible, type };
    });
  },
});
